import { RootState } from '@iwProvider/configureStore';
import _ from 'lodash';

export function getRBLFundingFee(state: RootState) {
    return _.get(state, 'api.rbl_estimated_schedule.data.summary.funding_fee');
}

export function getEstimatedTotalRepaymentAmount(state: RootState) {
    return _.get(
        state,
        'api.rbl_estimated_schedule.data.summary.total_payable'
    );
}

export function getEstimatedRepayments(state: RootState) {
    return _.get(
        state,
        'api.rbl_estimated_schedule.data.estimated_schedule.repayments',
        []
    );
}
